import styled from 'styled-components';

export const Title = styled.div`
  padding: 0 30px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
`;
export const Description = styled.div`
  margin-top: 6px;
  padding: 0 30px;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #4d4d4d;
`;

export const Content = styled.div`
  margin-top: 24px;
  text-align: center;
`;
